/**
 * Client-side application settings for the local development environment.
 */
export const local = {
  // Core application settings
  app: {
    name: 'Craft Admin',
    origin: 'http://localhost:3000',
    env: 'local' as 'local' | 'test' | 'prod' | 'staging',
  },
  api: 'http://localhost:8080/v1/graphql',
  portalUrl: 'https://portal.qa.craft.co',
  keyPeopleUrl: 'https://key-people-turbo-engine.data.qa.craft.co',
  locationsUrl: 'https://locations.data.qa.craft.co',
  newsUrl: 'https://craft.tryretool.com/apps/8c5f4b70-3d78-11ec-8f06-2738e600aed3/NewsUI/News%20Admin%20UI',
  craftCoUrl: 'https://qa.craft.co',
};

/**
 * Client-side application settings for the test / QA environment.
 */
export const qa: typeof local = {
  app: {
    ...local.app,
    origin: 'https://admin.qa.craft.co',
    env: 'test',
  },
  api: 'https://admin-v2.data.qa.craft.co/v1/graphql',
  portalUrl: 'https://portal.qa.craft.co',
  keyPeopleUrl: 'https://key-people-turbo-engine.data.qa.craft.co/admin',
  locationsUrl: 'https://locations.data.qa.craft.co/admin',
  newsUrl: 'https://craft.tryretool.com/apps/8c5f4b70-3d78-11ec-8f06-2738e600aed3/NewsUI/News%20Admin%20UI',
  craftCoUrl: 'https://qa.craft.co',
};

/**
 * Client-side application settings for the production environment.
 */
export const prod: typeof local = {
  app: {
    ...local.app,
    origin: 'https://admin.craft.co',
    env: 'prod',
  },
  api: 'https://admin-v2.data.craft.co/v1/graphql',
  portalUrl: 'https://portal.craft.co',
  keyPeopleUrl: 'https://key-people-turbo-engine.data.production.craft.co/admin',
  locationsUrl: 'https://locations.data.production.craft.co/admin',
  newsUrl: 'https://craft.tryretool.com/apps/8c5f4b70-3d78-11ec-8f06-2738e600aed3/NewsUI/NewsProduction',
  craftCoUrl: 'https://craft.co',
};

/**
 * Client-side application settings for the staging environment.
 */
export const staging: typeof local = {
  app: {
    ...local.app,
    origin: 'https://admin.staging.craft.co',
    env: 'staging',
  },
  api: 'https://admin-v2.data.staging.craft.co/v1/graphql',
  portalUrl: 'https://portal.staging.craft.co',
  keyPeopleUrl: 'https://key-people-turbo-engine.data.staging.craft.co/admin',
  locationsUrl: 'https://locations.data.staging.craft.co/admin',
  newsUrl: 'https://craft.tryretool.com/apps/8c5f4b70-3d78-11ec-8f06-2738e600aed3/NewsUI/News%20Admin%20UI',
  craftCoUrl: 'https://staging.craft.co',
};

const envs = {
  local,
  qa,
  staging,
  prod,
};

/**
 * Client-side application settings for the test / QA environment.
 */
export const config = {
  api: {
    url: `${process.env.CRAFT_ADMIN_API_URL}/graphql`,
  },
  logo: {
    cdnPrefix: process.env._Web_CraftCo_Aws_ImageCdnUrl,
    uploaderUrl: process.env._Data_CraftAdminUploader_Url ?? '',
  },
  portal: {
    url: process.env._PremiumPortal_Url,
    sso: {
      samlEntryRoute: '/saml/entry',
      samlCallbackRoute: '/saml/callback',
    },
  },
  env: envs[process.env.APP_ENV as keyof typeof envs],
};
